<mat-progress-bar mode="query" color="primary" *ngIf="loading"></mat-progress-bar>
